import { Price } from "~/common/Store/models/ProductListing";

export default (price: Price) => {
  const currentDate = new Date();

  return (
    price.displaySalePrice &&
    new Date(String(price.saleStartDate)) < currentDate &&
    currentDate < new Date(String(price.saleEndDate))
  );
};
